<script>
    import { ShowCoffeeModal } from '../../script/_init'
    
	let dialog, selectTab = 1;

    $: if (dialog && $ShowCoffeeModal) {
        dialog.showModal(); 
    }

	function closeModal() {
        ShowCoffeeModal.set(false)
        dialog.close()
	}

    function onClickTab(_tab) {
        selectTab = _tab
    }

</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<dialog
	bind:this={dialog}
	on:close={closeModal}
	on:click|self={() => dialog.close()}
	class='coffeeSponsor'
>
	<div style="height: 100%;" on:click|stopPropagation>
        <div class='title'>커피 한잔 후원</div>

        <hr>

        <p>소중한 시간과 노력(열정페이)으로 개발된 웹페이지입니다.</p>

        <p>혹시라도 해당 페이지가 도움이 되신 분들 중에 운영을 위한 커피 한잔정도 후원해 주실 분들은 아래의 QR 또는 링크를 통해 후원이 가능합니다.</p>

        <p>후원해주신 경우, 차후 후원자 페이지에 이름 또는 닉네임을 표시할 예정입니다.</p>

        <div class='tabMenu'>
            <div class='tab kakao' on:click={() => onClickTab(2)}>
                <div class='imageCenter'>
                    <img src="/img/tab_kakao.jpg" alt="tab_kakao">
                </div>
            </div>
            
            <div class='result kakao'>
                <div>
                    <img src="/img/qr_kakao.jpg" alt="qr_kakao"><br>
                    <a href='https://qr.kakaopay.com/281006011000075870028993' rel='noopener noreferrer' target='_blank'>
                        QR 코드 안되실 경우 (클릭)
                    </a>
                </div>
            </div>
        </div>

        <hr>

        <button on:click={() => dialog.close()}>닫 기</button>

        <div class='arrow-up'>
            {#each Array(15) as _}
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="12" viewBox="0 0 23 12" fill="none">
                    <path d="M11.822 0.52832L22.6688 11.6914H0.975134L11.822 0.52832Z" fill="black"/>
                    </svg>
            {/each}
        </div>
	</div>
</dialog>

<style lang='scss'>
    dialog {
        padding: 0;
        overflow: hidden;
        border-bottom: 1px solid black;

        &::backdrop {
            background: rgba(0, 0, 0, 0.8);
        }

        &[open] {
            animation: zoom 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        @keyframes zoom {
            from {
                transform: scale(0.95);
            }
            to {
                transform: scale(1);
            }
        }
        &[open]::backdrop {
            animation: fade 0.2s ease-out;
        }
        @keyframes fade {
            from {
                opacity: 0;
            }
            to {
                opacity: 1;
            }
        }
    }

    .coffeeSponsor{
        background-color: $cl2;
        width: calc(350px - 60px);
        height: fit-content;
        padding: 30px;
        
        position: relative;
        
        .title {
            width: 100%;
            margin-bottom: 30px;
            color: $cl3;
            font-size: 25px;
            font-family: 'bitbit';
            text-align: center;
        }
        .arrow-up {
            position: absolute;
            left: 2px;
            bottom: -1px;
        }

        .tabMenu {
            width: 100%;
            margin: 25px 0px;
            .tab {
                width: 50%;
                height: 35px;
                display: inline-block;
                cursor: pointer;
                
                &.toss { background: #0064FF; border-radius: 10px 0px 00px 0px; }
                &.kakao { background: #FFEB00; border-radius: 10px 10px 0px 0px; }

                .imageCenter {
                    width: 100%;
                    height: 100%;
                    
                    /* 정중앙 표시(높이 지정 필수) */
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }
            .result {
                width: 100%;
                height: 275px;
                border-radius: 0px 10px 10px 10px;
                text-align: center;
                    
                /* 정중앙 표시(높이 지정 필수) */
                display: flex;
                justify-content: center;
                align-items: center;

                &.toss {
                    background-color: #0064FF;
                    a { color: $cl2;}
                }
                &.kakao {
                    background-color: #FFEB00;
                    a { color: $cl1;}
                }

                a { font-size: 14px; text-decoration: underline; }
                img { width: 200px; margin-bottom: 14px;}
            }
        }

        p {
            margin: 8px 0px;
            color: $cl1;
            font-size: 14px;

            a {
                margin: 0px 5px;
                padding: 5px 10px;
                border: 1px solid $cl4;
                border-radius: 50px;
                color: $cl4;

                &:hover {
                    background-color: $cl4;
                    color: $cl2;
                }
            }
        }

        hr {
            margin: 25px 0px;
            border-bottom: 1px dashed #000000;
        }
        button {
            background-color: $cl2;
            width: 290px;
            height: 44px;

            border: 1px solid $cl3;
            border-radius: 50px;

            color: $cl3;
            font-size: 20px;
            font-family: 'bitbit';

            cursor: pointer;

            &:hover {
                background-color: $cl3;
                color: $cl2;
            }
        }

    }
</style>
